import Vue from 'vue';

export default Vue.component('section-slantleft-divider', {
  template: require('./template.html'),
  name: 'section-slantleft-divider',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/slant-left/index.js